<span [ngClass]="{ 'dashboard-title': isDashboard}">
    <h4>{{ sectionTitle.title }}</h4>
</span>
